import { useMemo } from 'react';
import TanoCharacter from '../../components/Eleve/TanoCharacter';
import { useXp } from '../../context/XpContext';
import { useTransactionsXp } from '../../hooks/fetch_api_hook/useTransactionsXp';
import { getMission, flammeSauveeAujourdhui } from '../../utils/rituel';
import { defisCreditesAffiches } from '../../utils/defisQuotidiens';
import { DEFIS_QUOTA_JOUR } from '../../utils/xpConfig';

/**
 * Carte « Mission du jour » de l'accueil — habille l'ancienne carte orange du
 * compteur de quiz. États : flamme en danger (carte pulsante), mission
 * nominale, tout fait (Tano dort), repos. Front-only, formulations prudentes
 * (frontière de journée estimée en local).
 */
function MissionDuJour({ total, nextQuizTitre }) {
    const { profil, isEleve } = useXp();
    const { data: transactions } = useTransactionsXp(profil?.xp_total, isEleve);

    const mission = useMemo(() => {
        const liste = Array.isArray(transactions) ? transactions : (transactions?.results || []);
        const normalisees = liste.map(t => ({ date: t.created_at ?? t.date ?? null }));
        return getMission({
            pending: total,
            nextQuizTitre,
            flammeJours: profil?.flamme_jours ?? 0,
            flammeSauvee: flammeSauveeAujourdhui(normalisees),
            defisRestants: Math.max(0, DEFIS_QUOTA_JOUR - defisCreditesAffiches(profil)),
        });
    }, [transactions, total, nextQuizTitre, profil]);

    const danger = mission.type === 'flamme-danger';

    return (
        <div
            className={`rounded-2xl p-4 text-white flex items-center gap-3${danger ? ' mission-danger' : ''}`}
            style={{
                background: danger
                    ? 'linear-gradient(120deg,#EA580C,#F97316)'
                    : 'linear-gradient(120deg,#F97316,#FFB938)',
                boxShadow: '0 10px 28px rgba(249,115,22,.4)',
            }}
        >
            <div className="flex-shrink-0" style={{ width: 64, height: 64 }}>
                <TanoCharacter
                    plume={profil?.skin_plumage}
                    acc={profil?.skin_accessoire}
                    aura={profil?.skin_aura}
                    mood={mission.mood}
                    size={64}
                />
            </div>
            <div className="min-w-0 flex-1 text-left">
                <p className="font-extrabold text-[15px] leading-tight" style={{ fontFamily: 'Fredoka' }}>{mission.titre}</p>
                <p className="text-xs font-bold mt-0.5 leading-snug" style={{ color: 'rgba(255,255,255,.9)' }}>{mission.sousTitre}</p>
            </div>
            {total > 0 && (
                <div className="flex-shrink-0 text-center px-2">
                    <div className="text-3xl font-extrabold leading-none" style={{ fontFamily: 'Fredoka' }}>{total}</div>
                    <div className="text-[10px] font-extrabold mt-0.5">quiz</div>
                </div>
            )}
        </div>
    );
}

export default MissionDuJour;
